import { render, staticRenderFns } from "./closeQueastion.vue?vue&type=template&id=c046b8e2&scoped=true&"
import script from "./closeQueastion.vue?vue&type=script&lang=js&"
export * from "./closeQueastion.vue?vue&type=script&lang=js&"
import style0 from "./closeQueastion.vue?vue&type=style&index=0&id=c046b8e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c046b8e2",
  null
  
)

export default component.exports